import easydropdown from 'easydropdown'

export default class Select {
  constructor(el) {
    this.el = el
    easydropdown(this.el)

    if (typeof $(this.el).data('navigation') !== 'undefined') {
      $(this.el).on('change', e => {
        const target = $(e.currentTarget).val()

        if (typeof target !== 'undefined') location.href = target
      })
    }
  }
}
